import React, { useState, useEffect } from 'react'
import { useSponsorLogo } from '../../utils/getSponsorLogo'
import { SponsorLogoStyles } from './styles'

export default function SponsorLogo() {
  const [data, setData] = useState(null)
  const [error, setError] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const strapiData = await useSponsorLogo()
        if (strapiData !== null && strapiData !== '') {
          setError(false)
          setData(strapiData)
        } else {
          setError(true)
        }
      } catch (e) {
        setError(true)
      }
    }
    fetchData()
  }, [])

  return (
    <>
      {!error && data !== null
        ? data.Platforms.web && data.Logo.data !== null && (
          <a href={data.ImageLink} target="_blank" style={{ backgroundImage: `url(${data.Logo.data.attributes.url})` }} className="SponsorLogo" rel="noreferrer">
            {data.Logo.data.attributes.caption}
          </a>
        ) : ''}
      <style jsx>{SponsorLogoStyles}</style>
    </>
  )
}
